import React from 'react';
import DataTable from 'react-data-table-component';
import { useNavigate } from 'react-router-dom';
import { formatDate } from '../../../helpers/formatDate';
import { IconEdit, IconEye, IconListCheck } from '@tabler/icons-react';
import { useNavigateWithSlugHook, } from "../../../../src/config/routes/guards/slug";

const DatatableUsers = (props) => {
  // console.log(props);
  const navigate = useNavigateWithSlugHook();
  const handleChangePage = (path) => {
    navigate(path);
  };

  const columns = [
    {
      name: 'Aksi',
      minWidth: '150px',
      cell: (row) => (
        <>
          <button
            className="btn btn-sm btn-outline-info"
            type="button"
            title="Detail Pengguna"
            onClick={() => props.handleDetail(row)}
          >
            <IconEye stroke={2} />
          </button>
          <button
            className="btn btn-sm btn-outline-warning"
            type="button"
            title="Ubah Pengguna"
            onClick={() => props.handleEdit(row)}
          >
            <IconEdit stroke={2} />
          </button>
          <button
            className="btn btn-sm btn-outline-dark"
            type="button"
            title="Mapping Bab Pengguna"
            onClick={() => props.handleMappingBab(row)}
          >
            <IconListCheck stroke={2} />
          </button>
          {/* <button
              className="btn btn-sm btn-outline-danger"
              type="button"
              title="Hapus Pengguna"
              onClick={() => props.handleHapus(row.id)}
            >
              <IconTrash stroke={2} />
            </button> */}
        </>
      ),
    },
    {
      name: 'Nama Lengkap',
      minWidth: '300px',
      selector: (row) => row.namaLengkap,
    },
    {
      name: 'Group',
      minWidth: '150px',
      selector: (row) => row.mapping_user_groups[0].group?.namaGroup,
    },
    {
      name: 'Active',
      minWidth: '100px',
      cell: (row) => (
        <>
          {row.active === 'YES' ? (
            <span className="badge bg-success">YES</span>
          ) : (
            <span className="badge bg-danger">NO</span>
          )}
        </>
      ),
    },
  ];

  return (
    <>
      <h5 className="card-title">Daftar Pengguna</h5>
      <div style={{ overflowX: 'auto', maxWidth: '1200px' }}>
        <DataTable
          columns={columns}
          data={props.users}
          pagination
          fixedHeader
          highlightOnHover
          subHeader
          subHeaderComponent={
            <input
              type="text"
              placeholder="Cari Nama Lengkap, Username"
              className="w-50 form-control m-3"
              values={props.search}
              onChange={(e) => {
                // Hanya izinkan huruf, angka, dan spasi
                const cleanValue = e.target.value.replace(/[^a-zA-Z0-9\s]/g, "");
                props.handleChangeSearch(cleanValue);
              }}
            />
          }
          subHeaderAlign="center"
        />
      </div>
    </>
  );
};

export default DatatableUsers;
